import { render, staticRenderFns } from "./wl.vue?vue&type=template&id=f0cc4486&scoped=true&"
import script from "./wl.vue?vue&type=script&lang=js&"
export * from "./wl.vue?vue&type=script&lang=js&"
import style0 from "./wl.vue?vue&type=style&index=0&id=f0cc4486&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cc4486",
  null
  
)

export default component.exports